// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OEZE","colBig":"styles_colBig__3LuBm","colSmall":"styles_colSmall__2dT0T"};